import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {championMasteryAPI} from "../../api/championMasteryAPI";
import useQueryRegion from "./useQueryRegion";

//랭킹 데이터는 CDN 캐시를 타고 내려온다. 탭을 옮겼다 돌아올 때마다 다시 받을 이유가 없어서
//같은 파라미터면 staleTime 동안 캐시를 그대로 쓴다.
const STALE_TIME = 5 * 60 * 1000;
const GC_TIME = 30 * 60 * 1000;

const useChampionMasteryQuery = ({champion_id, lane}) => {
    const [region] = useQueryRegion();

    const query = useQuery({
        queryKey: ['championMastery', champion_id, lane, region],
        queryFn: () => championMasteryAPI({
            platform_id: region || 'All',
            champion_id: champion_id || 0,
            lane: lane || 'All',
        }),
        //region이 정해지기 전에는 요청하지 않는다 (기존 useDispatchMastery와 동일)
        enabled: Boolean(region) && champion_id !== undefined,
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
        //파라미터가 바뀌어 새로 받는 동안 이전 목록을 그대로 보여준다.
        //로딩 때마다 테이블을 통째로 언마운트하지 않기 위함.
        placeholderData: keepPreviousData,
        retry: 0,
        refetchOnWindowFocus: false,
    });

    return {
        ranks: query.data ?? [],
        //캐시에 아무것도 없을 때만 로딩으로 본다.
        //실패한 경우엔 로딩을 풀어서 기존처럼 'no data' 화면으로 떨어지게 한다.
        isLoading: query.data === undefined && !query.isError,
        isError: query.isError,
    };
};

export default useChampionMasteryQuery;
